module.exports = __webpack_public_path__ + "static/media/konoike_color.7936beb6.jpg";